export default __webpack_public_path__ + "static/media/stock-photo.e488d08f.svg";